import { sortBy, get, set, find } from 'lodash'
import { useQuery } from 'react-query'
import hooks from '../../../hooks'
import moment from 'moment'
import useDimensions from '../../../hooks/use-dimensions'

const useDimensionCredits = ({
    userId
} = {}) => {

    const { api, endpoints, url, time } = hooks.useApi()
    const cacheKeys = hooks.useCacheKeys()
    const { data, isLoading: isLoadingDimensionCredits } = useQuery(
        [cacheKeys.COURSES, 'dimension-credits', userId],
        () => api.get(url(endpoints.userDimensionCredits, { userId })),
        {
            enabled: Boolean(userId),
            staleTime: time.HOUR
        }
    )

    const [ dimensions, { isLoading }] = useDimensions()

    const dimensionCredits = sortBy(data || [], ['date'])

    let semesters = []
    let maxCreditsPerSemester = 0

    //  Divide everything into semesters
    if (dimensionCredits.length && dimensions.length) {
        //  Create the semesters, we assume the array is already sorted by date
        const generateSemesterLabel = (date) => `${date.month() < 5 ? 'Spring' : 'Fall'} ${date.year()}`
        let semester
        dimensionCredits.forEach(dc => {
            const date = moment(dc.date)
            const semesterLabel = generateSemesterLabel(date)
            if (semester && semester.label !== semesterLabel ) {
                semester = undefined
            }
            if (!semester) {
                semester = {
                    label: semesterLabel,
                    dimensionCredits: [],
                }
                semesters.push(semester)
            }
            semester.dimensionCredits.push(dc)
        })

        //  go through each semester and sumarize the dimensions
        semesters.forEach(semester => {
            let semesterCredits = 0
            if (semester.dimensionCredits) {
                semester.dimensionCredits.forEach(dc => {
                    const { dimensionId, credits} = dc
                    const dimension = find(dimensions, { id: dimensionId })
                    const name = get(dimension, 'name', '')
                    semesterCredits += credits
                    set(semester, name, get(semester, name, 0) + credits)
                })
                delete semester.dimensionCredits
            }
            maxCreditsPerSemester = Math.max(semesterCredits, maxCreditsPerSemester)
        })
    }

    //  Build the colors and keys
    const keys = []
    const colors = {}
    dimensions.forEach(d => {
        colors[d.name] = d.color
        keys.push(d.name)
    })

    return {
        isLoadingDimensionCredits: isLoadingDimensionCredits || isLoading,
        dimensionCredits,
        semesters,
        maxCreditsPerSemester,
        keys,
        colors
    }
}

export default useDimensionCredits
